import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=500133d7&scoped=true&"
import script from "./ServiceInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500133d7",
  null
  
)

export default component.exports